import http from './http'
import { CODE_OK, CODE_NO_LOGIN, CODE_NOT_FOUND } from './config'
import store from '../store'
import router from '../router'
import moment from 'moment'
import md5 from 'js-md5'
import { Toast, Indicator } from 'mint-ui'
// 封装 get 请求 返回的是一个promise
export function get (url, params) {
  Indicator.open()
  return new Promise((resolve, reject) => {
    http.get(url, { params }).then(res => {
      resolve(res.data)
      Indicator.close()
    }).catch(err => {
      reject(err)
      Indicator.close()
    })
  })
}
// 封装 post 请求 返回的是一个promise
export function post (url, data = {}) {
  Indicator.open()
  if(store.getters.loginUser) {
    data.userId = store.getters.loginUser.id
    data.token = store.getters.loginUser.token
    data.timestamp = moment().format('x')
    data.sign = md5(`0${data.userId}乘${data.token}0${data.timestamp}站`)
  }
  return new Promise((resolve, reject) => {
    http.post(url, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      if(CODE_OK === res.data.code) {
        resolve(res.data.data)
      } else if(CODE_NO_LOGIN === res.data.code) {
        store.commit('loginUser', null)
        Toast(res.data.msg)
      } else if(CODE_NOT_FOUND === res.data.code) {
        router.replace({path: '/404'})
      } else {
        Toast(res.data.msg)
        reject(res.data)
      }
      Indicator.close()
    }).catch(err => {
      Toast('系统异常，请联系管理员。')
      reject(err)
      Indicator.close()
    })
  })
}

// 封装文件上传（multipart/form-data），不做 JSON 序列化
export function upload (url, data) {
  Indicator.open()
  return new Promise((resolve, reject) => {
    http.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      if (CODE_OK === res.data.code) {
        resolve(res.data.data)
      } else {
        Toast(res.data.msg)
        reject(res.data)
      }
      Indicator.close()
    }).catch(err => {
      Toast('系统异常，请联系管理员。')
      reject(err)
      Indicator.close()
    })
  })
}
// 获取配置
export const apiOptionGet = data => post('/api/option/get', data)
// 获取分类
export const apiTypeGet = data => post('/api/type/get', data)
// 获取标签
export const apiTagGet = data => post('/api/tag/get', data)
// 获取文章列表
export const apiPostGetList = data => post('/api/post/getList', data)
// 获取文章
export const apiPostGet = data => post('/api/post/get', data)
// 获取页面
export const apiPageGet = data => post('/api/page/get', data)
// 获取页面列表
export const apiPageGetList = data => post('/api/page/getList', data)
// 登录
export const apiLogin = data => post('/api/login', data)
// 发送邮箱登录验证码
export const apiSendLoginCode = data => post('/api/sendLoginCode', data)
// 上传头像（返回头像 URL）
export const apiUploadAvatar = data => upload('/api/uploadAvatar', data)
// 按邮箱获取用户资料（用于完善信息回显）
export const apiGetProfile = data => post('/api/getProfile', data)
// 登录后按 userId 获取当前用户资料（用于修改个人信息回显）
export const apiGetMyProfile = data => post('/api/getMyProfile', data)
// 完善信息（昵称等）
export const apiCompleteProfile = data => post('/api/completeProfile', data)
// 登录后个人中心修改资料
export const apiSaveProfile = data => post('/api/saveProfile', data)
// 绑定邮箱
export const apiBind = data => post('/api/bind', data)
// 换绑邮箱：发送验证码到新邮箱
export const apiSendBindEmailCode = data => post('/api/sendBindEmailCode', data)
// 换绑邮箱：确认验证码并更新
export const apiConfirmBindEmail = data => post('/api/confirmBindEmail', data)
// 校验登录
export const apiCheckLogin = data => post('/api/checkLogin', data)
// 评论列表
export const apiCommentGetList = data => post('/api/comment/getList', data)
// 保存评论
export const apiCommentSave = data => post('/api/comment/save', data)
// 删除评论
export const apiCommentDelete = data => post('/api/comment/delete', data)
// 举报评论
export const apiCommentTipOff = data => post('/api/comment/tipOff', data)
// 点赞保存
export const apiLikeSave = data => post('/api/like/save', data)
// 点赞删除
export const apiLikeDelete = data => post('/api/like/delete', data)

// 获取配置
export const adminOptionGet = data => post('/admin/option/get', data)
// 保存配置
export const adminOptionSave = data => post('/admin/option/save', data)
// 获取分类
export const adminTypeGet = data => post('/admin/type/get', data)
// 保存分类
export const adminTypeSave = data => post('/admin/type/save', data)
// 获取标签
export const adminTagGet = data => post('/admin/tag/get', data)
// 保存标签
export const adminTagSave = data => post('/admin/tag/save', data)
// 获取分类列表
export const adminTypeGetList = data => post('/admin/type/getList', data)
// 获取标签列表
export const adminTagGetList = data => post('/admin/tag/getList', data)
// 获取文章
export const adminPostGet = data => post('/admin/post/get', data)
// 保存文章
export const adminPostSave = data => post('/admin/post/save', data)
// 获取页面
export const adminPageGet = data => post('/admin/page/get', data)
// 保存页面
export const adminPageSave = data => post('/admin/page/save', data)
// 文章列表
export const adminPostGetList = data => post('/admin/post/getList', data)
// 页面列表
export const adminPageGetList = data => post('/admin/page/getList', data)
// 评论列表
export const adminCommentGetList = data => post('/admin/comment/getList', data)
// 删除评论
export const adminCommentDelete = data => post('/admin/comment/delete', data)
// 用户列表
export const adminUserGetList = data => post('/admin/user/getList', data)
// 用户禁言
export const adminUserMuted = data => post('/admin/user/muted', data)

// 获取表情
export const getBqJson = data => get('/bq.json', data)



// WEBPACK FOOTER //
// ./src/request/index.js